// extracted by mini-css-extract-plugin
module.exports = {"selectedTag":"selectedTag--30cAH","thumbnail":"thumbnail--1MrV4","content":"content--1BStE","value":"value--1D_eU","closeTagIcon":"closeTagIcon--1T9lN"};